
import { Vue } from "vue-class-component";

export default class LogoutBreadcrumb extends Vue {}
